import settings from 'Cloud/settings';
import { path, pathOr } from 'ramda';
import { getTrimmedText } from 'reactApp/utils/textHelpers';

export const getQueryParams: any = () => {
    return pathOr({}, ['request', 'query_params'], settings);
};

const { utm_source = '', utm_campaign = '', utm_term = '' } = getQueryParams();

export const getUtmSourceString = () => {
    if (!utm_source && !utm_campaign && !utm_term) {
        return '';
    }

    return getTrimmedText([utm_source, utm_campaign, utm_term].join(';'), 100);
}

export const getInitialRequestId = (): string | undefined => {
    return path(['request', 'id'], settings);
};
